import {IOnChanges, IOnChangesObject, IRootElementService} from "angular";
import {CollateralMovement} from "../models/PortfolioCollateral";

export const PendingLodgementIndicator = "tfPendingLodgementIndicator";

const popoverUrl = "app/portfolio/templates/collateral/pending-lodgement-indicator/PendingLodgementPopover.html";

const template = `
    <i class="icon-question pointer"
       style="color:rgb(199, 198, 198)"
       uib-popover-template="'${popoverUrl}'"
       popover-trigger="'mouseenter'"
       popover-append-to-body="false"
       popover-title="Pending Collateral Movement">
</i>
`;

export function pendingLodgementIndicator() {
    return {
        template,
        bindings: {
            pending: "<"
        },
        controllerAs: "ctrl",
        controller: PendingLodgementIndicatorController
    };
}

export class PendingLodgementIndicatorController implements IOnChanges {

    public pending: CollateralMovement | null;

    /** @ngInject */
    public constructor(private $element: IRootElementService) {

    }

    public $onChanges(changes: IOnChangesObject): void {
        if (this.pending == null) {
            this.$element.css("display", "none");
        } else {
            this.$element.css("display", "inline-block");
        }
    }
}
